import { useState, useEffect } from 'react';

export const useOrientacion = () => {
  const [orientacionSeleccionada, setOrientacionSeleccionada] = useState(() => {
    const orientacionGuardada = localStorage.getItem('orientacionSeleccionada');
    return orientacionGuardada ? JSON.parse(orientacionGuardada) : null;
  });

  // Save to localStorage when orientacion changes
  useEffect(() => {
    localStorage.setItem('orientacionSeleccionada', JSON.stringify(orientacionSeleccionada));
  }, [orientacionSeleccionada]);

  const resetOrientacion = () => {
    setOrientacionSeleccionada(null);
    localStorage.removeItem('orientacionSeleccionada');
  };

  return {
    orientacionSeleccionada,
    setOrientacionSeleccionada,
    resetOrientacion
  };
};
